import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, CardTitle, Col, Form, Row } from "reactstrap";
import { Link } from "react-router-dom";
import Dropzone from "react-dropzone";
import { showInfoMessage } from "../../../../helpers/utils";
import { useEffect } from "react";

const Setup = props => {
  useEffect(() => {
    if (props.files[0].path !== "") {
      props.onClickSetNextActive(true);
    } else {
      props.onClickSetNextActive(false);
    }
  }, [props.files[0].path]);

  const handleAcceptedFiles = files => {
    let file_type = files[0].path.split(".").pop();
    let file_types = ["csv", "xlsx"];
    if (file_types.indexOf(file_type) >= 0) {
      files.map(file =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          formattedSize: formatBytes(file.size),
        })
      );

      props.setSelectedFiles(files);
      props.updateFiles(files);
    } else {
      showInfoMessage(
        "Unavailable format, add files with .csv or .xlsx format!"
      );
    }
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  return (
    <React.Fragment>
      <CardTitle className="h4">Upload widget: Setup</CardTitle>
      <p className="card-title-desc">
        For uploading widget you need to provide the data in a CSV or XLSX file
        format.
      </p>

      <Form>
        <Dropzone onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}>
          {({ getRootProps, getInputProps }) => (
            <StyledDropzone className="dropzone">
              <div className="dz-message needsclick" {...getRootProps()}>
                <input {...getInputProps()} />
                <div className="mb-3">
                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                </div>
                <h4>Drop files here or click to upload.</h4>
              </div>
            </StyledDropzone>
          )}
        </Dropzone>
        <div className="dropzone-previews mt-3" id="file-previews">
          {props.selectedFiles.map((f, i) => {
            return (
              <Card
                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                key={i + "-file"}
              >
                <div className="p-2">
                  <Row className="align-items-center">
                    <Col className="col-auto">
                      <i
                        className="mdi mdi-file-document font-size-22 align-middle text-primary "
                        style={{ marginLeft: "13px" }}
                      />
                    </Col>
                    <Col>
                      <Link to="#" className="text-muted font-weight-bold">
                        {f.name}
                      </Link>
                      <p className="mb-0">
                        <strong>{f.formattedSize}</strong>
                      </p>
                    </Col>
                  </Row>
                </div>
              </Card>
            );
          })}
        </div>
      </Form>
      <div>
        <p className="text-muted p-0 m-0 mt-3">
          * The maximum uploading file size is <strong>1 MB</strong>
        </p>
      </div>
    </React.Fragment>
  );
};

const StyledDropzone = styled.div`
  min-height: 130px;
  .dropzone {
    min-height: 130px !important;
  }
`;

Setup.propTypes = {
  onClickSetNextActive: PropTypes.func,
  files: PropTypes.array,
  updateFiles: PropTypes.func,
  setSelectedFiles: PropTypes.func,
  selectedFiles: PropTypes.array,
};

export default connect()(Setup);
